export const RESERVATIONS_PATH = "/reservations";
export const NRVS_PATH = "/nrvs";
export const CUSTOMERS_PATH = "/customers";
export const INVOICES_PATH = "/invoices";
export const TRANSACTION_PATH = "/transaction";
export const TASK_BOARD_PATH = "/tasks/board";
export const COIN_ORDERS_PATH = "/coin-orders";
export const COIN_TRANSFERS_PATH = "/coin-transfers";

export const reservationDetailPath = (key) => {
  if (!key) return RESERVATIONS_PATH;
  return `${RESERVATIONS_PATH}/${encodeURIComponent(String(key))}`;
};

export const nrvDetailPath = (key) => {
  if (!key) return NRVS_PATH;
  return `${NRVS_PATH}/${encodeURIComponent(String(key))}`;
};

export const customerDetailPath = (key) => {
  if (!key) return CUSTOMERS_PATH;
  return `${CUSTOMERS_PATH}/${encodeURIComponent(String(key))}`;
};

export const accountInvoiceDetailPath = (key) => {
  if (!key) return INVOICES_PATH;
  return `${INVOICES_PATH}/${encodeURIComponent(String(key))}`;
};

export const transactionPath = ({ customerId } = {}) => {
  if (!customerId) return TRANSACTION_PATH;
  const params = new URLSearchParams({
    customerId: String(customerId),
  });
  return `${TRANSACTION_PATH}?${params.toString()}`;
};

export const taskBoardPath = ({ taskType, bookingId, paymentId } = {}) => {
  const params = new URLSearchParams();
  if (taskType) {
    params.set("taskType", String(taskType));
  }
  if (bookingId) {
    params.set("bookingId", String(bookingId));
  }
  if (paymentId) {
    params.set("paymentId", String(paymentId));
  }
  const query = params.toString();
  return query ? `${TASK_BOARD_PATH}?${query}` : TASK_BOARD_PATH;
};

export const coinOrderDetailPath = (key) => {
  if (!key) return COIN_ORDERS_PATH;
  return `${COIN_ORDERS_PATH}/${encodeURIComponent(String(key))}`;
};

export const coinTransfersPath = () => COIN_TRANSFERS_PATH;

export const isMongoId = (value) => {
  if (!value) return false;
  return /^[a-f\d]{24}$/i.test(String(value));
};
